export default "@media screen {\n  :host {\n    display: none;\n  }\n}"